import React from 'react';

function Hero() {
    return (
        <header className="col-10 offset-1 hero-header">
            <h1>Guess the Image.!</h1>
            <p>Select the appropricate answer for the pictures Shown.</p>
        </header>
    )
}

export default Hero;